import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Trail from "../../components/Trail/Trail";
import Footer from "../../components/Footer/Footer";
import ContactDemoComponent from "../../components/Contact-demo-component/ContactDemoComponent";
import CompanyInfo from "../../components/Company Info/CompanyInfo";

export default function ContactDemo() {
  return (
    <>
      <Navbar />
      <ContactDemoComponent />
      <CompanyInfo />
      <Trail />
      <Footer />
    </>
  );
}
